import { NavLink, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../context/AuthContext";
import { requestWithoutToken } from "../utils/apis";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { useState, useRef } from "react";

export default function Login({ totalLength = 6, onChangeOtp }) {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState()
  const [otp, setOtp] = useState(Array(totalLength).fill(""));
  const inputsRef = useRef([]);
  const [showOTPbox, setShowOTPbox] = useState(false)
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
    otp: Yup.string().when([], {
      is: () => showOTPbox === true,
      then: (schema) => schema.required("OTP is required").length(6, "OTP must be 6 digits"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formik = useFormik({
    initialValues: { email: "", otp: "" },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true)
        if (showOTPbox) {
          const payload = {
            email: values.email,
            otp: values.otp,
            type: "otp",
          };

          const result = await requestWithoutToken("POST", "/api/user/signin", payload);

          if (result?.data.status) {
            const res = result.data.data;
            localStorage.setItem("token", res?.token);
            console.log(result.data)
            localStorage.setItem("shortcode", res?.project_shortcode);
            login();
            toast.success(result.data.message);
            navigate("/pages");
          } else {
            toast.error(result.data.message);
          }
        } else {
          delete values.otp;
          const result = await requestWithoutToken("POST", "/api/user/send-otp", values);
          if (result?.data.status) {
            toast.success(result.data.message);
            setShowOTPbox(true)
          } else {
            toast.error(result.data.message);
          }
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong. Please try again.");
      } finally {
        setLoading(false)
      }
    },
  });

  const sendOTP = async () => {
    try {
      const response = await requestWithoutToken("POST", "/api/user/send-otp", { email: formik.values.email });
      if (response?.data.status) {
        setOtp(Array(totalLength).fill(""));
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Failed to send OTP");
    }
  }

  const handleChange = (element, index) => {
    const value = element.value.replace(/\D/, ""); // only digits
    formik.setFieldValue("otp", value)

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    const joinedOtp = newOtp.join("");
    formik.setFieldValue("otp", joinedOtp);
    if (onChangeOtp) onChangeOtp(newOtp.join(""));
    // Move to next box automatically
    if (value && index < totalLength - 1) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (otp[index]) {
        // If current box has a value, clear it
        newOtp[index] = "";
        setOtp(newOtp);
        if (onChangeOtp) onChangeOtp(newOtp.join(""));
      } else if (index > 0) {
        // If empty, move to previous
        inputsRef.current[index - 1].focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
        if (onChangeOtp) onChangeOtp(newOtp.join(""));
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim().slice(0, totalLength);
    if (!/^\d+$/.test(pastedData)) return;

    const newOtp = pastedData.split("");
    for (let i = newOtp.length; i < totalLength; i++) newOtp.push("");
    setOtp(newOtp);
    const joinedOtp = newOtp.join("");
    formik.setFieldValue("otp", joinedOtp);
    if (onChangeOtp) onChangeOtp(newOtp.join(""));

    // Move focus to last filled input
    const nextIndex = Math.min(pastedData.length, totalLength - 1);
    inputsRef.current[nextIndex].focus();
  };
  return (
    <div className="login-sec">
      <div className="login-form-sec">
        <form onSubmit={formik.handleSubmit}>
          {
            !showOTPbox ? (<div className="login-form">
              <h1 className="heading1">Login to continue</h1>
              <p className="subheading">Enter your email address to receive a one-time passcode</p>
              <div className="frm-group">
                <label className="frm-label">Email</label>
                <input
                  type="email"
                  name="email"
                  className={`frm-input ${formik.touched.email && formik.errors.email ? "error" : ""}`}
                  placeholder="Enter your email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div style={{ color: "red" }}>{formik.errors.email}</div>
                )}
              </div>
              <div className="logbtn-group mt-4">
                <button type="submit" className="btn-black w-100">
                  {loading ? <Spinner size="sm" /> : "Send OTP"}
                </button>
              </div>
            </div>) :
              (
                <div className="login-form">
                  <h1 className="heading1">Enter OTP</h1>
                  <p className="subheading">We’ve sent a 6-digit code to {formik.values.email}.</p>
                  <div className="otp-container">
                    <div className="otp-inputs">
                      {otp.map((data, index) => (
                        <input
                          key={index}
                          type="text"
                          className="otp-box"
                          maxLength="1"
                          value={data}
                          onChange={(e) => { console.log(e.target.value); handleChange(e.target, index); }}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          onPaste={handlePaste}
                          ref={(el) => (inputsRef.current[index] = el)}
                        />
                      ))}
                     
                    </div>
                    {formik.touched.otp && formik.errors.otp && (
                      <div style={{ color: "red" }}>{formik.errors.otp}</div>
                    )}
                    <button className="resend-link"
                      type="button"
                      onClick={() => {
                        sendOTP();
                      }}
                    >Resend OTP</button>
                  </div>
                  <div className="logbtn-group mt-4">
                    <button type="submit" className="btn-black w-100">
                      {loading ? <Spinner size="sm" /> : "Verify & Login"}
                    </button>
                  </div>
                  <p className="logfooter">Not this account? <button type="button" onClick={() => {
                    setOtp(Array(totalLength).fill(""))
                    setShowOTPbox(false);
                    formik.resetForm()
                  }} className="btn-link1">Change Email</button></p>
                </div>
              )
          }
        </form>
      </div>
    </div>
  );
}
